var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-switch',{staticClass:"mb-6",attrs:{"label":_vm.label,"color":"primary","hide-details":""},on:{"change":_vm.onActivateChange},model:{value:(_vm.activate),callback:function ($$v) {_vm.activate=$$v},expression:"activate"}}),_c('h5',[_vm._v("Click back to make any changes.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }